@keyframes transition {
  from { width: 100% }
  to { width: 0 } 
}

.indicator {
  height: 5px;
  background-color: #cdcd44;
  animation: var(--animation-time) linear 1 forwards transition;
}